import Streams from './Streams.container';

export default Streams;



// WEBPACK FOOTER //
// ./src/ui/streams/index.js